import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { Space } from '@sravni/react-design-system';
import { type ComponentProps, useCallback, useMemo } from 'react';

import { Switch } from 'shared/ui/Switch';

import { type TAdditionalDataFormFields, useDictionaries } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';

export const PropertyTypeAvailability: FC<IFieldFactoryProps> = (props) => {
  const { watch, setValue } = useFormContext<TAdditionalDataFormFields>();
  const { propertyTypeAvailabilityTypes } = useDictionaries(['propertyTypeAvailabilityTypes']);
  const { type, ...other } = props;
  const isOpen = watch('propertyTypeAvailabilityToggleEnabled');

  const nothingOption = useMemo(
    () => propertyTypeAvailabilityTypes.find((item) => item.value === 'Nothing'),
    [propertyTypeAvailabilityTypes],
  );

  const handleToggle: ComponentProps<typeof Switch>['onChange'] = useCallback(
    (event) => {
      const value = event.currentTarget.checked;
      setValue('propertyTypeAvailabilityToggleEnabled', value);
      if (!value) {
        setValue('propertyTypeAvailability', nothingOption || null, { shouldValidate: true });
      }
    },
    [setValue, nothingOption],
  );

  const options = useMemo(
    () => propertyTypeAvailabilityTypes.filter((item) => item.value !== 'Nothing'),
    [propertyTypeAvailabilityTypes],
  );

  return (
    <Space
      direction="vertical"
      size={16}
    >
      <Switch
        checked={isOpen}
        onChange={handleToggle}
      >
        {AdditionalInfoTexts.propertyTypeAvailabilityToggleEnabled}
      </Switch>
      {isOpen && (
        <ControlledCustomSelect
          {...other}
          name={type}
          options={options}
          withCrossIcon={false}
        />
      )}
    </Space>
  );
};
